export default __webpack_public_path__ + "static/media/na.1af09e74.svg";